import { Link } from 'react-router-dom';
import Section from "./Section";
import { socials } from "../constants"; // Ensure your social media icons are in this array

const Footer = () => {
  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Adds smooth scrolling
    });
  };

  return (
    <Section className="bg-black text-white py-12">
      <div className="container mx-auto grid gap-8 md:grid-cols-3 justify-between items-start">
        
        {/* Explore Column */}
      
        <div className="flex flex-col space-y-4">
          <h3 className="text-lg sm:text-xl font-semibold">Explore</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/FuteurCred" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
                FuteurCred
              </Link>
            </li>
            <li>
              <Link to="/SeeHowItWorks" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
                See How It Works
              </Link>
            </li>
            <li>
              <Link to="/credit-comparsion" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
                Business vs. Personal Credit
              </Link>
            </li>
            <li>
              <a
                href="https://futeur.freshdesk.com/support/home"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-400 transition-colors"
              >
                Help Center
              </a>
            </li>
          </ul>
        </div>

        {/* Company Column */}
        <div className="flex flex-col space-y-4">
          <h3 className="text-lg sm:text-xl font-semibold">Company</h3>
          <ul className="space-y-2">
          <li>
          <Link to="/legal" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
            Legal
          </Link>
        </li>
          <li>
          <Link to="/about-futeur" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
            About
          </Link>
        </li>
        <li>
        <Link to="/vision" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
          Vision
        </Link>
      </li>
      <li>
      <Link to="/careers" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
        Careers
      </Link>
    </li>
            <li>
              <Link to="/contact" className="hover:text-gray-400 transition-colors" onClick={scrollToTop}>
                Contact
              </Link>
            </li>
           
          </ul>
        </div>

        {/* Social Media Icons */}
        <div className="flex flex-col space-y-4">
          <h3 className="text-lg sm:text-xl font-semibold">Follow Us</h3>
          <div className="flex space-x-3 mt-2">
            {socials.map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 border border-gray-500 rounded-full hover:bg-gray-800 transition-colors"
                onClick={scrollToTop}
              >
                <img src={item.iconUrl} width={16} height={16} alt={item.title} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="mt-8 text-center text-sm text-gray-500">
      © 2025 FuteurAI.<br/> Futeur® is a registered trademark. All rights reserved. Building tomorrow, empowering today.
      </div>
    </Section>
  );
};

export default Footer;

